import {PlacePresentationValueObject} from "../../../model/vo/content/place/PlacePresentationValueObject";
import {defaultIO} from "../../DefaultIO";
import {httpClient} from "../../HttpClient";
import {PlaceValueObject} from "../../../model/vo/content/place/PlaceValueObject";

export const PlaceIO = {
    ...defaultIO(
        '/api/v3/contents/places',
        PlaceValueObject.construct
    ),
    getPlacePresentationForUser(externalId:string,requiredImageCount:number,isParticipating:boolean,placePathJointId:string | null,campaignCode: string ,attractionId: string | null | undefined ): Promise<PlacePresentationValueObject> {
        const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent)

        let osType = 'Android'

        if (isIOS) osType = 'IOS'

        console.log(isParticipating,placePathJointId)

        const url = `/api/v3/contents/places/presentation?externalId=${externalId}&osType=${osType}&requiredImageCount=${requiredImageCount}&isParticipating=${isParticipating}&campaignCode=${campaignCode}`+ (isParticipating? `&idEqual=${placePathJointId}` : ``) + (attractionId? `&attractionId=${attractionId}` : ``)

        console.log(`/api/v3/contents/places/presentation?externalId=${externalId}&osType=${osType}&requiredImageCount=${requiredImageCount}&isParticipating=${isParticipating}&campaignCode=${campaignCode}`+ (isParticipating? `&idEqual=${placePathJointId}` : ``) + (attractionId? `&attractionId=${attractionId}` : ``))

        return httpClient.get(
            url
            , PlacePresentationValueObject.construct)
    },
}